import React, { useState } from "react";
import { useAuth } from "../services/AuthContext";

const ProfileConfig = ({ i18n, t }) => {
  const { updateLanguage } = useAuth();
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  const handleLanguageChange = async (event) => {
      const newLanguage = event.target.value;

      // Mettre à jour la langue dans l'app
      i18n.changeLanguage(newLanguage);
      setSelectedLanguage(newLanguage);

      try {
      await updateLanguage(newLanguage);
    } catch (error) {
          throw new Error("Erreur lors de la sauvegarde de la langue");
       } finally {
    }
  };

  return (
    <div className="config-section">
      <h2>{t("profile.config.title")}</h2>

      <div className="form-group">
        <label htmlFor="language-select">
          {t("profile.config.lang")}
        </label>
       <select
          id="language-select"
          value={selectedLanguage}
          onChange={handleLanguageChange}
        >
          <option value="en">English</option>
          <option value="fr">Français</option>
        </select>
      </div>
    </div>
  );
};

export default ProfileConfig;
